var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { attrs: { cols: "12", md: "3" } },
    [
      _c(
        "v-card",
        { staticClass: "ma-2" },
        [
          _c(
            "v-card-title",
            { staticClass: "title font-weight-black" },
            [
              _c("v-icon", { staticClass: "pr-3" }, [_vm._v("home")]),
              _vm._v(" Register New Hotel\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-container",
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _c(
                          "fieldset",
                          [
                            _c("legend", [_vm._v("Basic Details")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "mb-4" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.bookableViaIescape,
                                    expression: "bookableViaIescape",
                                  },
                                ],
                                attrs: {
                                  name: "bookable_via_iescape",
                                  type: "checkbox",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.bookableViaIescape)
                                    ? _vm._i(_vm.bookableViaIescape, null) > -1
                                    : _vm.bookableViaIescape,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.bookableViaIescape,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.bookableViaIescape = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.bookableViaIescape = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.bookableViaIescape = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "bookableViaIescape" } },
                                [_vm._v("Bookable via i-escape")]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: {
                                label: "Hotel Name",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.hotelName,
                                callback: function ($$v) {
                                  _vm.hotelName = $$v
                                },
                                expression: "hotelName",
                              },
                            }),
                            _vm._v(" "),
                            _c("v-autocomplete", {
                              attrs: {
                                label: "Region",
                                items: _vm.regions,
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.regionKey,
                                callback: function ($$v) {
                                  _vm.regionKey = $$v
                                },
                                expression: "regionKey",
                              },
                            }),
                            _vm._v(" "),
                            _c("v-autocomplete", {
                              attrs: {
                                label: "Billing Type",
                                items: _vm.billingTypes,
                                outlined: "",
                                dense: "",
                                disabled:
                                  !_vm.bookableViaIescape &&
                                  !_vm.bookableViaPartner &&
                                  !_vm.bookableViaDirect,
                              },
                              model: {
                                value: _vm.billing,
                                callback: function ($$v) {
                                  _vm.billing = $$v
                                },
                                expression: "billing",
                              },
                            }),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: {
                                label: "Commission (%)",
                                disabled:
                                  !_vm.bookableViaIescape &&
                                  !_vm.bookableViaPartner &&
                                  !_vm.bookableViaDirect,
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.commission,
                                callback: function ($$v) {
                                  _vm.commission = $$v
                                },
                                expression: "commission",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                staticClass: "lime",
                                attrs: { disabled: _vm.saving },
                                on: {
                                  click: function ($event) {
                                    return _vm.save()
                                  },
                                },
                              },
                              [_vm._v("Create")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }